module.exports = __webpack_public_path__ + "img/Angiogenesis-LICA_PLC.d968821a.png";